/* SR-016 — Collection Filtering by Bike Type — hardcode of the Intelligems win.

   "Find the right rack" bike-type pill selector above the collection grid
   (/collections/*). Tap a bike type -> non-matching rack cards hide, matching
   ones stay; a line reports what's left. No reload.

   Ported verbatim from Jono's SR-016-v1 Intelligems injection, with the
   injection-only scaffolding removed (Clarity tagging, igEvents/fireEvent).
   Behaviour is identical. Loaded from sections/collection.liquid, so it only
   runs on collection pages; it also self-suppresses when the grid has fewer
   than two distinct racks (accessory / single-rack collections).

   Classification reads the RENDERED cards on purpose: on these collections the
   grid includes the SR-006 ProFlex variant cards (one product -> Narrow/Wide/
   Fat cards) and bundle cards, which a server-side classify of
   collection.products could not see. Pair with SR-016 CSS in the section. */

;(function () {
  'use strict';
  if (window.__sr016_loaded) return;
  window.__sr016_loaded = true;

  if (!/^\/collections\//.test(window.location.pathname)) return;

  // The seven base rack keys. Cards (incl. bundles) classify to one of these
  // by handle + title, never by numeric variant ID (which churns).
  var CARD_KEYS = ['ProFlex Narrow', 'ProFlex Wide', 'ProFlex Fat', 'Classic MTB', 'Classic Road', 'Classic Fat', 'Classic Fender'];

  var TYPES = [
    { id: 'all',      label: 'All bikes',  fits: CARD_KEYS },
    { id: 'road',     label: 'Road',       fits: ['ProFlex Narrow', 'Classic Road'] },
    { id: 'mountain', label: 'Mountain',   fits: ['ProFlex Wide', 'Classic MTB'] },
    { id: 'hybrid',   label: 'Hybrid',     fits: ['ProFlex Narrow', 'Classic MTB'] },
    { id: 'gravel',   label: 'Gravel',     fits: ['ProFlex Narrow', 'ProFlex Wide', 'Classic MTB'] },
    { id: 'ebike',    label: 'eBike',      fits: ['ProFlex Wide', 'ProFlex Fat', 'Classic MTB'] },
    { id: 'fat',      label: 'Fat Bike',   fits: ['ProFlex Fat', 'Classic Fat'] },
    { id: 'bmx',      label: 'BMX',        fits: ['ProFlex Narrow', 'Classic Road'] }
  ];

  // ---- DOM ----
  function findGridArea() {
    var products = document.querySelector('[data-collection-products]');
    if (!products) return null;
    var grid = products.querySelector('.l-collection__products-grid') || products;
    return { products: products, grid: grid };
  }

  // Classify a card to one of the seven base rack keys. Works for base product
  // cards AND bundle cards (Portable / GearMate bundles), which wrap a rack:
  //   - ProFlex bundles handle/title carry 'proflex' + the variant
  //     (portable-proflex-narrow-bundle, proflex-fat-gearmate-bundle, ...)
  //   - Classic portable bundles use the bike-type word, no 'proflex'
  //     (portable-mtb-bundle = Classic MTB, portable-road-bike-bundle = Classic
  //     Road, portable-fat-bike-bundle = Classic Fat - confirmed on each PDP)
  // ProFlex vs Classic is decided by whether 'proflex' appears; the variant /
  // type word picks the exact rack. Positive classification only (Principle 1):
  // anything we can't place (accessories, GearMate-only) is left alone.
  function classifyCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var handle = (link.getAttribute('href') || '').split('?')[0].toLowerCase();
    var title = (link.getAttribute('title') || link.textContent || '').toLowerCase();
    var hay = handle + ' ' + title;

    if (hay.indexOf('proflex') !== -1) {
      if (hay.indexOf('narrow') !== -1) return 'ProFlex Narrow';
      if (hay.indexOf('wide') !== -1) return 'ProFlex Wide';
      if (hay.indexOf('fat') !== -1) return 'ProFlex Fat';
      return null; // ProFlex but no variant word - don't guess
    }
    // Classic racks + Classic portable bundles.
    if (hay.indexOf('classic') !== -1 || hay.indexOf('bundle') !== -1) {
      if (hay.indexOf('mtb') !== -1) return 'Classic MTB';
      if (hay.indexOf('road') !== -1) return 'Classic Road';
      if (hay.indexOf('fender') !== -1) return 'Classic Fender';
      if (hay.indexOf('fat') !== -1) return 'Classic Fat';
    }
    return null;
  }

  function classifyCards(grid) {
    var cards = grid.querySelectorAll('l-product-card, .l-productCard');
    var map = [];
    for (var i = 0; i < cards.length; i++) {
      var key = classifyCard(cards[i]);
      if (!key) continue;
      var link = cards[i].querySelector('a[href*="/products/"]');
      var hay = (((link && link.getAttribute('href')) || '') + ' ' + ((link && (link.getAttribute('title') || link.textContent)) || '')).toLowerCase();
      map.push({ el: cards[i], key: key, bundle: hay.indexOf('bundle') !== -1 });
    }
    return map;
  }

  function applyFilter(typeId, section) {
    var type = null;
    for (var i = 0; i < TYPES.length; i++) if (TYPES[i].id === typeId) type = TYPES[i];
    if (!type) return;

    // Re-classify fresh on every click so the filter + count always reflect the
    // CURRENT DOM. The grid populates progressively, so a list cached at
    // inject() time could be partial (early on it holds only the server-rendered
    // SR-006 ProFlex cards, before Classic/GearMate/bundle cards arrive).
    var area = findGridArea();
    if (!area) return;
    var grid = area.grid;
    var cardMap = classifyCards(grid);

    for (var c = 0; c < cardMap.length; c++) {
      var fits = type.fits.indexOf(cardMap[c].key) !== -1;
      cardMap[c].el.classList[fits ? 'remove' : 'add']('sr016-hidden');
    }

    // Range headings ('ProFlex Range' / 'Classic Range') only make sense for
    // the full list. Once a filter is active, drop them so the matching racks
    // from different ranges flow onto one continuous row instead of being
    // split under two headings. Restore them on 'All bikes'.
    var headings = grid.querySelectorAll('.sr-range-heading');
    for (var h = 0; h < headings.length; h++) {
      headings[h].classList[typeId === 'all' ? 'remove' : 'add']('sr016-hidden');
    }

    // Pill active state + result line
    var pills = section.querySelectorAll('.sr016-pill');
    for (var t = 0; t < pills.length; t++) {
      pills[t].classList[pills[t].getAttribute('data-sr016-type') === typeId ? 'add' : 'remove']('sr016-active');
    }
    var line = section.querySelector('.sr016-result');
    if (typeId === 'all') {
      line.textContent = '';
      line.hidden = true;
    } else {
      var n = 0, anyBundle = false;
      for (var m = 0; m < cardMap.length; m++) {
        if (cardMap[m].el.classList.contains('sr016-hidden')) continue;
        n++;
        if (cardMap[m].bundle) anyBundle = true;
      }
      // 'racks' when the result is rack-only; 'options' once a bundle is in the
      // mix (a bundle isn't strictly a rack), so the count stays honest.
      var unit = anyBundle ? 'option' : 'rack';
      // Labels that already say 'bike' (Fat Bike, eBike) get pluralised in
      // place; others get ' bikes' appended. Avoids 'fat bike bikes'.
      var noun = type.label.toLowerCase();
      noun = noun.indexOf('bike') !== -1 ? noun.replace(/bike$/, 'bikes') : noun + ' bikes';
      if (type.id === 'ebike') noun = 'eBikes'; // brand casing, not 'ebikes'
      line.textContent = 'Showing ' + n + ' ' + unit + (n === 1 ? ' that fits ' : 's that fit ') + noun;
      line.hidden = false;
    }
  }

  function buildSection(cardMap) {
    var section = document.createElement('section');
    section.id = 'sr016-finder';
    var pills = '';
    for (var i = 0; i < TYPES.length; i++) {
      // Only offer types that match at least one card on this page.
      var hasMatch = false;
      for (var c = 0; c < cardMap.length; c++) {
        if (TYPES[i].fits.indexOf(cardMap[c].key) !== -1) { hasMatch = true; break; }
      }
      if (!hasMatch) continue;
      pills +=
        '<button class="sr016-pill' + (TYPES[i].id === 'all' ? ' sr016-active' : '') + '" data-sr016-type="' + TYPES[i].id + '" type="button">' +
          TYPES[i].label +
        '</button>';
    }
    section.innerHTML =
      '<p class="sr016-label">Filter by bike type</p>' +
      '<div class="sr016-pills">' + pills + '</div>' +
      '<p class="sr016-result" hidden></p>';
    section.addEventListener('click', function (e) {
      var pill = e.target.closest ? e.target.closest('.sr016-pill') : null;
      if (!pill) return;
      applyFilter(pill.getAttribute('data-sr016-type'), section);
    });
    return section;
  }

  var lastCardCount = -1;

  function inject() {
    if (document.getElementById('sr016-finder')) return true;
    var area = findGridArea();
    if (!area) return false;
    // Wait until the grid stops growing (card count stable across two polls) so
    // the pills + initial classification are built from the COMPLETE grid, not a
    // partial one caught mid-render. The grid populates progressively — the
    // server-rendered SR-006 ProFlex cards land first, the rest after.
    var count = area.grid.querySelectorAll('l-product-card, .l-productCard').length;
    if (count !== lastCardCount) { lastCardCount = count; return false; }

    var cardMap = classifyCards(area.grid);
    // Need a real choice: at least 2 distinct racks, else leave page alone
    // (accessory collections, single-product ranges).
    var distinct = {};
    for (var i = 0; i < cardMap.length; i++) distinct[cardMap[i].key] = 1;
    if (Object.keys(distinct).length < 2) return false;
    var section = buildSection(cardMap);
    area.products.parentNode.insertBefore(section, area.products);
    return true;
  }

  if (!inject()) {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (inject() || attempts >= 60) clearInterval(poll); // 15s ceiling
    }, 250);
  }
})();
